import type { SlotFeederHint } from "../utils/bracketFeeders";
import { entitySlug } from "../utils/slug";
import { EntityLogo } from "./EntityLogo";

export function FeederPlaceholder({ gameId, hint }: { gameId: string; hint?: SlotFeederHint }) {
  if (hint?.candidates.length === 2) {
    return <span className="feeder-candidates" title={hint.label} aria-label={hint.label}>
      {hint.candidates.map((candidate, index) => {
        const organizationId = candidate.teamId || `${gameId}/${entitySlug(candidate.name)}`;
        return <span key={candidate.name}>{index > 0 && <i>/</i>}<EntityLogo src={candidate.logo || `/media/organization/${organizationId}`} name={candidate.name} /></span>;
      })}
    </span>;
  }
  return <span className="feeder-label" title={hint?.label ?? "Participant to be determined"}>{hint?.label ?? "TBD"}</span>;
}
